export default __webpack_public_path__ + "static/media/logo_kemenhan.bdd49486.png";